import { message } from 'antd';
import { all, call, put, takeLatest, takeEvery } from "redux-saga/effects";
import { getLockedVisitsAPI, unlockVisitAPI } from '../../../services/locked-visits-service';
import { GET_LOCKED_VISITS, GET_LOCKED_VISITS_ERROR, GET_LOCKED_VISITS_START, GET_LOCKED_VISITS_SUCCESS, UNLOCK_VISIT, UNLOCK_VISIT_ERROR, UNLOCK_VISIT_SUCCESS } from '../../actions/admin/lockedVisitsAction';



function* fetchLockedVisits({ }) {

    try {
        yield put({ type: GET_LOCKED_VISITS_START })
        const response = yield call(getLockedVisitsAPI);

        if (response.success) {
            yield put({ type: GET_LOCKED_VISITS_SUCCESS, lockedVisits: response.data.length > 0 ? [...response.data] : [] })
        } else {
            yield put({ type: GET_LOCKED_VISITS_ERROR, error: response.error })
            message.error('Failed to fetch locked visits!');
        }
    } catch (error) {
        message.error('Failed to fetch locked visits!');
        yield put({ type: GET_LOCKED_VISITS_ERROR, 'error': error })
    }
}

function* unlockVisit({ visit }) {

    try {
        const response = yield call(unlockVisitAPI, visit.reportId);

        if (response.success) {
            message.success('Unlocked visit successfully.');
            yield put({ type: UNLOCK_VISIT_SUCCESS, visit: visit })
        } else {
            yield put({ type: UNLOCK_VISIT_ERROR, error: response.error })
        }
    } catch (error) {
        message.error('Failed to unlock visit!');
        yield put({ type: UNLOCK_VISIT_ERROR, 'error': error })
    }
}


function* getLockedVisitsWatcher() {
    yield takeEvery(GET_LOCKED_VISITS, fetchLockedVisits)
}

function* unlockVisitWatcher() {
    yield takeLatest(UNLOCK_VISIT, unlockVisit)
}

export default function* rootSaga() {
    yield all([getLockedVisitsWatcher(), unlockVisitWatcher()])
}

